window.initEverNearProduct ?? (() => {
    window.initEverNearProduct = (section_id) => {

        const stickyFooterBar = document.querySelector('.product-sticky-footer');
        const checkoutBtn = document.querySelector('#checkout');
        const everNearProduct = document.querySelector(`section#shopify-section-${section_id} .consultation-recommendation-product`);

        const addDiscountLine = () => {
            const termOptionsWrap = everNearProduct.querySelector(`.payment-field`);

            termOptionsWrap.querySelector('.payment-option[data-payment="annual"]').classList.add('active-extra-offer');
           
           if(everNearProduct.querySelector('span.savings-total')) {
                everNearProduct.querySelectorAll('span.savings-total').forEach(savingTotal => {
                    savingTotal.innerText = '£117';
                    savingTotal.dataset.price = '£117';
                    savingTotal.dataset.priceVat = '£137.40';
                });
            }

            window.product_json.variants.forEach((variant) => {
                if(variant.id == termOptionsWrap.querySelector('.payment-option[data-payment="annual"]').dataset.id) {
                    let total_bundle = variant.price;
                    total_bundle -= termOptionsWrap.querySelector('.payment-option[data-payment="annual"]').dataset.offer;
                    total_bundle -= termOptionsWrap.querySelector('.payment-option[data-payment="annual"]').dataset.extraOffer;

                    termOptionsWrap.querySelector('.payment-option[data-payment="annual"] .total-line .price').innerText = `£${total_bundle / 100}`;
                    termOptionsWrap.querySelector('.payment-option[data-payment="annual"] .total-line .price').dataset.price = `£${total_bundle / 100}`;

                    let total_bundle_vat = variant.price * 1.2;
                    total_bundle_vat -= termOptionsWrap.querySelector('.payment-option[data-payment="annual"]').dataset.offer * 1.2;
                    total_bundle_vat -= termOptionsWrap.querySelector('.payment-option[data-payment="annual"]').dataset.extraOffer;
                    termOptionsWrap.querySelector('.payment-option[data-payment="annual"] .total-line .price').dataset.priceVat = `£${(total_bundle_vat / 100).toFixed(2)}`;
                }
            });

        }

        const applyDiscount = () => {

          if(window.localStorage.getItem('evernear-discount')) {
            addDiscountLine();
          }
   
          const params = new URLSearchParams(window.location.search);
          const discount = params.get('discount');

          if (discount == 'EN15S2') {
            console.log('Discount applied:', discount);
            window.localStorage.setItem('evernear-discount', discount);

            addDiscountLine();

            fetch(`/discount/${discount}`)
            .then(() => {
                //addDiscountLine();
            });
          }
        }

        applyDiscount();

        const getStoredData = () => {
            if(window.localStorage.getItem('consultation-data-details')) {
                window.consultation_data = JSON.parse(window.localStorage.getItem('consultation-data-details'));
            }
        }

        getStoredData();

        const sendConsultationDataLayerEvent = (step, event, title, action, answer, result) => {

            try {
                
                let cons_event = {
                    'event': event,
                    'cons_type': 'Consultation Flow v2', 
                    'cons_step_number': step
                }

                if (window.consultation_data && window.consultation_data.cons_funnel_number) {
                    cons_event.cons_funnel_number = parseInt(window.consultation_data.cons_funnel_number)+1
                }

                if(title) {
                    cons_event.cons_step_name = title;
                }

                if(action) {
                    cons_event.cons_other_action = action;
                }
            
                if(answer) {
                    cons_event.cons_answer = answer;
                } else if(result) {
                    cons_event.cons_result = result;
                } 
            
                console.log(cons_event);
        
                dataLayer.push(cons_event);  
            } catch (error) {
                console.error(error);
            }
        }

        sendConsultationDataLayerEvent(
            'last', 
            'cons_completed', 
            'Recommendation Page', 
            false,
            false,
            location.pathname.replace('/products/','')
        );

        const consultationActions = () => {
            //const consultationCloseBtn = document.querySelector('.consultation-recommendation .consultation-close');
            const consultationRestartBtn = document.querySelector('.consultation-recommendation .consultation-back');

            const removeStoredSelection = () => {
                window.localStorage.removeItem('consultation-data');
                window.localStorage.removeItem('consultation-data-details');
            }

            /*const closeConsultation = () => {

                sendConsultationDataLayerEvent(
                    6,
                    'cons_other_event', 
                    'Recommendation Page', 
                    'Close',
                    false,
                    false
                );
                if(document.referrer && document.referrer.startsWith(document.location.origin)) {
                    document.location = document.referrer;
                } else {
                    document.location = document.location.origin;
                }
            }*/

            const restartConsultation = () => {
                if(confirm('Are you sure you want to restart?')) {
                    sendConsultationDataLayerEvent(
                        6,
                        'cons_other_event', 
                        'Recommendation Page', 
                        'Restart',
                        false,
                        false
                    );
                    removeStoredSelection();
                    document.location = `${document.location.origin}/pages/book-a-consultation`;
                }
            }

            consultationRestartBtn.addEventListener('click', restartConsultation);
            //consultationCloseBtn.addEventListener('click', closeConsultation);
        }

        consultationActions();

        const purchaseOptions = () => {
            //const termsSelector = everNearProduct.querySelector(`.terms-wrap`);
            //const termOptions = everNearProduct.querySelectorAll(`.term-variant-wrap`);
            const termOptions = everNearProduct.querySelectorAll(`.payment-option`);
            //const termsInfo = everNearProduct.querySelector(`.terms-variants-wrap`);
            const termsInfo = everNearProduct.querySelector(`.payment-field`);
            const upsellItem = everNearProduct.querySelector(`.product-upsells .upsell-item`);

            const getBundleComponents = (handle) => {
                const query = `
                    query ProductBundleComponents($handle: String!) {
                        product(handle: $handle) {
                            id
                            title
                            variants(first: 20) {
                                nodes {
                                    id
                                    title
                                    requiresComponents
                                    components(first: 20) {
                                        nodes {
                                            quantity
                                            productVariant {
                                                id
                                                title
                                            product {
                                                    id
                                                    title
                                                    handle
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    `;

                fetch('/api/2026-04/graphql.json', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': 'cdb80b3d2229be2f10e09eb8210b2b38'
                    },
                    body: JSON.stringify({
                        query,
                        variables: {
                            handle
                        }
                    })
                })
                .then(response => response.json())
                .then(data => {

                    console.log(data);

                    if(handle == window.product_json.handle) {
                        const fetched_bundle_variants =
                        data?.data?.product?.variants?.nodes || [];

                        window.product_json.variants.forEach((variant, index) => {
                            variant.bundle_variants = [];
                            fetched_bundle_variants.forEach(fetched_variant => {
                                if(fetched_variant.id.indexOf(variant.id) > 0) {
                                    console.log('in if');
                                    let variant_components = fetched_variant.components?.nodes || [];
                                    variant_components.forEach(variant_component => {
                                        variant.bundle_variants.push(variant_component.productVariant.id.replace('gid://shopify/ProductVariant/',''));
                                    });
                                }
                            });
                        });

                        updateFooter();
                    } else {
                        const fetched_bundle_vat_variants =
                        data?.data?.product?.variants?.nodes || [];

                        window.product_json_vat.variants.forEach((variant, index) => {
                            variant.bundle_variants = [];
                            fetched_bundle_vat_variants.forEach(fetched_variant => {
                                if(fetched_variant.id.indexOf(variant.id) > 0) {
                                    console.log('in if');
                                    let variant_components = fetched_variant.components?.nodes || [];
                                    variant_components.forEach(variant_component => {
                                        variant.bundle_variants.push(variant_component.productVariant.id.replace('gid://shopify/ProductVariant/',''));
                                    });
                                }
                            });
                        });

                        updateFooter();
                    }
                    
                })
                .catch(error => {
                    console.error('GraphQL error:', error);
                });
            }

            const updateFooter = () => {
                let has_upsell = false;
                if(upsellItem && upsellItem.querySelector('.add-upsell.added')) {
                    has_upsell = true;
                }
                window.bundle_to_add = '';
                let product_json_to_add = window.product_json;
                if(!everNearProduct.querySelector('.vat-box .variant-radio.selected')) {
                    product_json_to_add = window.product_json_vat;
                }
                product_json_to_add.variants.forEach((variant) => {
                    //if(variant.id == termsInfo.querySelector('.payment-option.selected').dataset.id) {
                    if(variant.title.toLowerCase() == termsInfo.querySelector('.payment-option.selected').dataset.payment) {
                        let total_today = variant.price;
                        let permalink = `/cart/${variant.id}:1`;

                        if(variant.bundle_variants && variant.bundle_variants.length > 0) {
                            permalink = '/cart/';
                            variant.bundle_variants.forEach(bundle_item => {
                                if (permalink != '/cart/') {
                                    permalink += ',';
                                }
                                permalink += `${bundle_item}:1`;

                                if(window.bundle_to_add != '') {
                                    window.bundle_to_add += ',';
                                }
                                window.bundle_to_add += bundle_item;
                            });
                        }

                        if(termsInfo.querySelector('.payment-option.selected') &&
                           termsInfo.querySelector('.payment-option.selected').dataset.offer) {
                            total_today -= parseInt(termsInfo.querySelector('.payment-option.selected').dataset.offer);
                            if(!everNearProduct.querySelector('.vat-box .variant-radio.selected')) {
                                total_today -= 600;
                            }
                        }

                        if(has_upsell) {
                            total_today += parseInt(upsellItem.querySelector('.add-upsell.added').dataset.price);
                            permalink += `,${upsellItem.querySelector('.add-upsell.added').dataset.id}:1`;
                        }

                        if(termsInfo.querySelector('.payment-option.selected.active-extra-offer') &&
                           termsInfo.querySelector('.payment-option.selected.active-extra-offer').dataset.extraOffer) {
                            total_today -= parseInt(termsInfo.querySelector('.payment-option.selected').dataset.extraOffer);
                            permalink += '?discount=EN15S2';
                        }

                        //permalink += '?storefront=true';

                        /*if(window.consultation_data?.first_name && window.consultation_data?.surname) {
                            if(permalink.indexOf('?') < 0) {
                                permalink += '?';
                            } else {
                                permalink += '&';
                            }
                            permalink += `checkout[shipping_address][first_name]=${encodeURIComponent(window.consultation_data.first_name || '')}` +
                                         `&checkout[shipping_address][last_name]=${encodeURIComponent(window.consultation_data.surname || '')}`;
                        }*/

                        if(window.add_subscription_plan) {
                            if(permalink.indexOf('?') < 0) {
                                permalink += '?';
                            } else {
                                permalink += '&';
                            }
                            permalink += 'attributes[selling_plan_apply]=true';
                        }

                        if (Number.isInteger(total_today / 100)) {
                            total_today = total_today / 100;
                        } else {
                            total_today = (total_today / 100).toFixed(2);
                        }

                        stickyFooterBar.querySelector('.total-price-today').innerText = `£${total_today}`;
                        stickyFooterBar.querySelector('.button').href = permalink;
                    }
                });
            }

            /*const selectTermToggle = (ev) => {
                let term = ev.currentTarget;

                if(term.classList.contains('active')) {
                    return false;
                }

                termsInfo.querySelectorAll('.term-variant').forEach(termInfo => {
                    if(termInfo.dataset.term == term.dataset.term) {
                        termInfo.classList.add('active');
                    } else {
                        termInfo.classList.remove('active');
                    }
                });

                updateFooter();
            }*/

            const selectTerm = (ev) => {
                let term = ev.currentTarget;

                /*if(term.querySelector('.term-variant').classList.contains('active')) {
                    return false;
                } else {
                    everNearProduct.querySelector('.term-variant.active').classList.remove('active');
                    term.querySelector('.term-variant').classList.add('active');
                    updateFooter();
                }*/

                if(term.classList.contains('selected')) {
                    return false;
                } else {
                    everNearProduct.querySelector('.payment-option.selected').classList.remove('selected');
                    term.classList.add('selected');
                    updateFooter();
                }
            }

            /*termsSelector.querySelectorAll('.term-option').forEach(termSelector => {
                termSelector.addEventListener('click', selectTermToggle);
            });*/

            termOptions.forEach(termOption => {
                termOption.addEventListener('click', selectTerm);
            });

            const addUpsell = (ev) => {
                ev.currentTarget.classList.add('added');
                ev.currentTarget.querySelector('span').innerText = 'Added to order';
                updateFooter();
            }

            if (upsellItem) {
                upsellItem.querySelector('.add-upsell').addEventListener('click', addUpsell);
            }


            const checkout = (ev) => {
                ev.preventDefault();
                window.localStorage.setItem('bundle_added', window.bundle_to_add);

                sendConsultationDataLayerEvent(
                    6,
                    'cons_add_to_cart', 
                    'Recommendation Page', 
                    false,
                    false,
                    window.location.pathname.replace('/products/','')
                );
                setTimeout(function(){
                    window.location = stickyFooterBar.querySelector('.button').href;
                },100);
            }

            getBundleComponents(window.product_json.handle);
            stickyFooterBar.querySelector('a.button').addEventListener('click', checkout);
            checkoutBtn.addEventListener('click', checkout);

            const updatePrices = () => {
                everNearProduct.querySelectorAll('[data-price]').forEach(price => {
                    if(everNearProduct.querySelector('.vat-box .variant-radio.selected')) {
                        price.innerText = price.dataset.price;
                    } else {
                        price.innerText = price.dataset.priceVat;
                    }
                });
                document.querySelectorAll('.evernear-popup-modal [data-price]').forEach(price => {
                    if(everNearProduct.querySelector('.vat-box .variant-radio.selected')) {
                        price.innerText = price.dataset.price;
                    } else {
                        price.innerText = price.dataset.priceVat;
                    }
                });
            }

            const vatOptions = () => {

                getBundleComponents(window.product_json_vat.handle);

                const updateVat = () => {
                    everNearProduct.querySelector('.vat-box .variant-radio').classList.toggle('selected');

                    if(everNearProduct.querySelector('.vat-box .variant-radio.selected')) {
                        localStorage.removeItem('vatCheckbox', false); 
                        localStorage.setItem('consultation-data',window.product_json.handle);
                    } else {
                        localStorage.setItem('vatCheckbox', false); 
                        localStorage.setItem('consultation-data',window.product_json_vat.handle);
                    }
                    
                    updatePrices();
                    updateFooter();
                }

                everNearProduct.querySelector('.vat-box .variant-radio').addEventListener('click', updateVat);

                if(localStorage.getItem('vatCheckbox') == 'false') {
                    everNearProduct.querySelector('.vat-box .variant-radio').click();
                }
            }

            vatOptions();

        }

        purchaseOptions();

        console.log('everNear Product');
    

        const personalisePage = () => {
            //const everNearIntro = document.querySelector(`section#shopify-section-${section_id} .consultation-recommendation-intro`);

            if(window.location.search.indexOf('rel=') > 0 || window.consultation_data) {
                /*
                let user_relation = '';
                if(window.location.search.indexOf('rel=') > 0) {
                    let pdp_url = new URL(window.location);
                    user_relation = pdp_url.searchParams.get('rel');
                } else if(window.consultation_data) {
                    user_relation = window.consultation_data.relationship;
                }
                
                let current_text = everNearIntro.querySelector('.intro-subheading-other').textContent;
                if (user_relation && user_relation == 'Myself' || user_relation.indexOf('Someone') >= 0 || user_relation == '') {
                    everNearIntro.querySelector('.intro-subheading-other').style.display = 'none';
                    everNearIntro.querySelector('.intro-subheading-myself').style.display = 'block';
                    everNearIntro.querySelector('.intro-subheading-myself').classList.add('shown');
                } else if (user_relation && user_relation.indexOf('A ') == 0) {
                    let user_relation_fix = user_relation.replace('A ','').toLowerCase();
                    let new_text = current_text.replace('[relationship]', user_relation_fix);
                    everNearIntro.querySelector('.intro-subheading-other').textContent = new_text;
                    everNearIntro.querySelector('.intro-subheading-other').classList.add('shown');
                } else if(user_relation) {
                    let new_text = current_text.replace('[relationship]', user_relation.toLowerCase())
                    everNearIntro.querySelector('.intro-subheading-other').textContent = new_text;
                    everNearIntro.querySelector('.intro-subheading-other').classList.add('shown');
                }
                */
                let payment_chosen = '';
                if(window.location.search.indexOf('payment=') > 0) {
                    let pdp_url = new URL(window.location);
                    payment_chosen = pdp_url.searchParams.get('payment');
                } else if(window.consultation_data?.payment) {
                    payment_chosen = window.consultation_data.payment;
                }
                
                if(payment_chosen == 'monthly') {
                    everNearProduct.querySelector(`.payment-option[data-payment="monthly"]`).click();
                }
                if(payment_chosen != '') {
                    everNearProduct.classList.add(payment_chosen);
                }
                window.localStorage.setItem('consultation-data', window.location.pathname.replace('/products/',''));
            } else if(window.localStorage.getItem('consultation-data')) {
                // update personalisation 
                /*
                everNearIntro.querySelector('.intro-subheading-other').style.display = 'none';
                everNearIntro.querySelector('.intro-subheading-myself').style.display = 'block';
                everNearIntro.querySelector('.intro-subheading-myself').classList.add('shown');
                */
            } else {
                // redirect
                if (!Shopify.designMode) {
                    // in theme editor
                    document.location = `${document.location.origin}/pages/book-a-consultation`;
                }
            }

            everNearProduct.style.opacity = 1;
        }

        personalisePage();

        const swiper = new Swiper('.product-details .swiper', {
            slidesPerView: 1.2,
            spaceBetween: 15,
            overflow: 'visible',
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: ".swiper-pagination",
                dynamicBullets: true,
            },
            breakpoints: {
                450: {
                    slidesPerView: 1.8,
                    spaceBetween: 20
                },
                750: {
                    slidesPerView: 2.3,
                    spaceBetween: 20
                },
                990: {
                    slidesPerView: 1,
                    spaceBetween: 20
                }
            }
        });

        window.addEventListener('resize', () => {
            swiper.update();
        });

        const stickyFooter = () => {

            const breakdownTotal = document.querySelector('.breakdown-total');

            if (!stickyFooterBar) return;

            const showFooter = () => {
                stickyFooterBar.classList.add('visible');
            }

            if(!breakdownTotal) {
                showFooter();
                return;
            }

            const isAboveFold = (el) => {
                const rect = el.getBoundingClientRect();
                if(rect.bottom <= window.innerHeight - 100) {
                    showFooter();
                    window.removeEventListener('scroll', isAboveFold);
                }
            }

            isAboveFold(breakdownTotal);

            window.addEventListener('scroll', function() {
                isAboveFold(breakdownTotal);
            });

        }

        stickyFooter();

        const replaceTitleTMs = () => {
            document.querySelectorAll(`section#shopify-section-${section_id} .consultation-recommendation-intro-wrap h1`).forEach((title) => {
                title.innerHTML = title.innerHTML.replace(
                    /™/g,
                    '<span class="tm">™</span>'
                    );
            });
        }

        replaceTitleTMs();

    }
  
})();
